<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 21">
    <g clip-path="url(#clip0_6892_9017)">
      <path
        d="M10.0014 6.93009L9.96607 7.17714L10.7543 7.06597C10.7543 7.06597 10.7778 7.06597 10.7896 7.06597L11.5425 7.16479L11.5072 6.94244C12.7896 6.69538 15.4014 6.05303 16.8837 4.70656C17.4602 4.18773 17.7896 3.48361 17.7896 2.73009C17.7896 1.97656 17.472 1.27244 16.8837 0.753615C15.7778 -0.246973 13.872 -0.246973 12.7661 0.753615C11.8131 1.61832 11.1661 2.89067 10.7543 4.00244C10.3425 2.89067 9.69548 1.61832 8.74254 0.765968C7.63666 -0.23462 5.73077 -0.23462 4.62489 0.765968C4.04842 1.28479 3.71901 1.98891 3.71901 2.74244C3.71901 3.49597 4.03666 4.18773 4.62489 4.71891C6.11901 6.05303 8.71901 6.69538 10.0014 6.94244V6.93009ZM13.5308 1.69244C13.872 1.38361 14.3308 1.21067 14.8249 1.21067C15.319 1.21067 15.7778 1.38361 16.119 1.69244C16.4367 1.97656 16.6131 2.34714 16.6131 2.73009C16.6131 3.11303 16.4367 3.48361 16.119 3.76773C14.9072 4.85479 12.6719 5.44773 11.4484 5.69479C11.7308 4.59538 12.3661 2.73009 13.519 1.69244H13.5308ZM5.3896 1.69244C5.73077 1.38361 6.1896 1.22303 6.68371 1.22303C7.17783 1.22303 7.63666 1.39597 7.97783 1.69244C9.13077 2.71773 9.7543 4.58303 10.0484 5.67009C8.82489 5.42303 6.60136 4.84244 5.3896 3.75538C5.07195 3.47126 4.90724 3.11303 4.90724 2.73009C4.90724 2.34714 5.08371 1.97656 5.40136 1.69244H5.3896ZM20.7896 7.3995H0.777832V12.3407H1.9543V20.9877H19.6014V12.3407H20.7778V7.3995H20.7896ZM9.00136 8.63479H12.5425L13.8014 15.8489L11.8602 14.9966L10.3308 16.4789L9.01313 8.62244L9.00136 8.63479ZM1.96607 8.63479H7.80136L8.21313 11.1054H1.9543V8.63479H1.96607ZM18.4367 19.7524H3.13077V12.3407H8.41313L9.51901 18.9371L12.0837 16.4419L15.319 17.8501L14.3661 12.3283H18.4249V19.7401L18.4367 19.7524ZM19.6131 11.1054H14.1543L13.7308 8.63479H19.6131V11.1054Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9017">
        <rect width="20" height="21" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
